import { useFramework } from '@/framework';
import { getLocaleStore } from '@/i18n';
import { LayerType } from '@/version-types';
import { ContextMenuPluginDependency } from '../../../dependency';
import { IExportContextMenuItem, IRenderContextMenuItemArgs } from '../../../type';
import MenuItem from '../../../views/menu-item';

const render = ({ activeLayer, pickLayer, operateLayerType, isImageEditor }: IRenderContextMenuItemArgs) => {
    const { $t } = getLocaleStore();
    const framework = useFramework();
    const layer = pickLayer || activeLayer;
    const disabled = !layer;

    // 禁用设置背景功能
    if (!layer) return null;
    if (isImageEditor) return null;
    if (operateLayerType !== LayerType.IMAGE_LAYER) return null;
    if (!framework.checkPossibleSplit(layer)) return null;

    const item = {
        disabled,
        name: $t((v) => v.contextMenuLayer.menuConfig.backgroundSet),
        type: 'backgroundSet',
        icon: 'BecomeBackgroundBold',
        onClick: () => {
            framework
                .getInstance(ContextMenuPluginDependency)
                .convertImageToBackground(
                    layer.id,
                    framework.checkIsGroup(layer),
                    framework.checkIsTextMaterialVip(activeLayer) ? activeLayer?.materialIds : undefined,
                );
        },
    };

    return <MenuItem {...item}></MenuItem>;
};

export default {
    group: 1,
    sort: 3,
    render,
} as IExportContextMenuItem;
